module.exports = __webpack_public_path__ + "img/thunder.e96d5271.svg";